import { useCallback } from "react";
import api from "../../services/api";

const useMyActivities = () => {
  const list = useCallback(async () => {
    const { data } = await api.get("/activities/mine");
    return data;
  }, []);

  const completeSchedule = useCallback(async (scheduleId) => {
    const { data } = await api.post(`/schedules/${scheduleId}/send-now`);
    return data;
  }, []);

  const toggleTaskStatus = useCallback(async (taskId, status) => {
    const { data } = await api.put(`/tasks/${taskId}`, { status });
    return data;
  }, []);

  return { list, completeSchedule, toggleTaskStatus };
};

export default useMyActivities;
